module.exports = __webpack_public_path__ + "static/media/PartnersSvg.392f4f3e.svg";